import React from 'react';
import { Above } from '@jetshop/ui/Breakpoints';
import { styled } from 'linaria/react';
import ProductTabs from './ProductTabs';
import ProductAccordion from './ProductAccordion';
import { useQuery } from '@apollo/react-hooks';
import BrandsQuery from './BrandsQuery.gql';

const ProductInfo = ({ product, setRemoteOpenIndex, remoteOpenIndex }) => {
  const ProductInfoWrapper = styled('section')`
    width: 100%;
  `;

  const brandsCategoryResult = useQuery(BrandsQuery, {
    variables: {
      id: 177
    }
  });

  return (
    <ProductInfoWrapper id="product-tabs">
      <Above breakpoint="md">
        {matches =>
          matches ? (
            <ProductTabs
              product={product}
              setRemoteOpenIndex={setRemoteOpenIndex}
              remoteOpenIndex={remoteOpenIndex}
              brandsCategoryResult={
                brandsCategoryResult?.data?.category?.subcategories
              }
            />
          ) : (
            <ProductAccordion
              product={product}
              setRemoteOpenIndex={setRemoteOpenIndex}
              remoteOpenIndex={remoteOpenIndex}
              brandsCategoryResult={
                brandsCategoryResult?.data?.category?.subcategories
              }
            />
          )
        }
      </Above>
    </ProductInfoWrapper>
  );
};

export default ProductInfo;
